import img1 from "./WhatsApp Image 2025-11-25 at 4.14.41 PM.jpeg";
import img2 from "./WhatsApp Image 2025-11-25 at 4.14.42 PM (1).jpeg";
import img3 from "./WhatsApp Image 2025-11-25 at 4.14.42 PM (2).jpeg";
import img4 from "./WhatsApp Image 2025-11-25 at 4.14.42 PM.jpeg";
import img5 from "./WhatsApp Image 2025-11-25 at 4.14.43 PM (1).jpeg";
import img6 from "./WhatsApp Image 2025-11-25 at 4.14.43 PM (2).jpeg";
import img7 from "./WhatsApp Image 2025-11-25 at 4.14.43 PM.jpeg";
import img8 from "./WhatsApp Image 2025-11-25 at 4.14.44 PM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
];
